import { gsap } from "gsap";
import { useEffect } from "react";

export function useDataWIdAnimation34() {
  useEffect(() => {
    gsap.set('[data-w-id="f1fa4d25-0761-4e48-a8ae-fda59b8e8919"]', {"y": "10%"});
    gsap.set('[data-w-id="f1fa4d25-0761-4e48-a8ae-fda59b8e8919"]', {"opacity": 0});
                const tl = gsap.timeline({"scrollTrigger": {"trigger": "[data-w-id=\"f1fa4d25-0761-4e48-a8ae-fda59b8e8919\"]", "start": "top 70%", "end": "bottom top", "toggleActions": "play none none none", "once": true}});
      tl.addLabel("label0");
      tl.to('[data-w-id="f1fa4d25-0761-4e48-a8ae-fda59b8e8919"]', {"duration": 0.5, "delay": 0.8, "ease": "power1.inOut", "y": "0%"}, "label0");
      tl.to('[data-w-id="f1fa4d25-0761-4e48-a8ae-fda59b8e8919"]', {"duration": 0.5, "delay": 0.8, "ease": "power1.inOut", "opacity": 1}, "label0");
    return () => {
      tl.kill();
    };
  }, []);
}